// extracted by mini-css-extract-plugin
module.exports = {"layout":"css_layout__1ViXw"};